import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import axios from "axios";

import { connect } from "react-redux";


import Spinner from "../../common/Spinner";

//
import TextFieldGroup from "../../common/TextFieldGroup";
import TextFieldGroupPlain from "../../common/TextFieldGroupPlain";
import TextAreaGroup from "../../common/TextAreaGroup";
import isEmpty from "../../common/is-empty";

import SelectCategoryGroup from "../../common/SelectCategoryGroup";
//import ImageDisplay from "../common/ImageDisplay";
//import MapLookup from "../common/MapLookup";
import { modifyAccommodation, insertAccommodation } from "../../../actions/dealsActions";




class AccommodationForm extends Component {
  constructor(props) {
    super(props);
    // console.log("props in advertisement", props);
    // console.log("id is", this.props.match.params.id);

    this.state = {
      _id: "",
      id: "",
      // property_id: "",
      title: "",
      start_date: "",
      end_date: "",
      price: "",
      retail: "",
      bedrooms: 0,
      baths: 0,
      room_type: "",
      categories: "",
      booking_url: "",
      //  status_flag: "",
      delete_flag: "",
      // lok: 0,
      // ppn: 0,
      which: '',

      property_key: "",
      errors: {},
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // this.onFileInputChange = this.onFileInputChange.bind(this);
    // this.handleMapClick = this.handleMapClick.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    // console.log('getDerivedStateFromProps flash',props.flashMsg.message);
    return {
      errors: props.errors
    };
  }

  componentDidMount() {

    this.loadState(this.props);

  }

  loadState = (props) => {


    this.setState(
      {
        which: props.accom.which,
        _id: props.accom._id,
        id: props.accom.id,
        company_id: props.accom.company_id,

        title: props.accom.title,
        start_date: props.accom.start_date,
        end_date: props.accom.end_date,
        price: props.accom.price,
        retail: props.accom.retail,
        bedrooms: props.accom.bedrooms,
        baths: props.accom.baths,
        room_type: props.accom.room_type,
        categories: props.accom.categories,
        booking_url: props.accom.booking_url,
        // status_flag: props.accom.status_flag,
        delete_flag: props.accom.delete_flag,
        //  lok: props.accom.lok,
        //  ppn: props.accom.ppn,
        property_key: props.accom.property_key,

      }
    )

  }

  // if we have errors this will run
  // componentWillReceiveProps(nextProps) {
  //   //console.log("register componentWillReceiveProps");
  //   if (nextProps.errors) {
  //     this.setState({ errors: nextProps.errors });
  //   }
  //   if ((this.props.accom.id) !== (nextProps.accom.id)) {
  //     this.loadState(nextProps);
  //   }
  // }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    // if (!isEmpty(this.props.errors)) {
    //   this.setState({ errors: this.props.errors });
    // }
    if ((this.props.accom.timemillis) !== (prevProps.accom.timemillis)) {
      this.loadState(this.props);
    }

  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  // handleChange(event) {
  //   this.setState({value: event.target.value});
  // }
  handleMapClick(lat, lon) {
    let slat = lat.toString();
    let slon = lon.toString();
    this.setState({ latitude: lat, longitude: lon });
  }

  onFileInputChange(e) {
    // console.log(e.target.files[0]);
    if (e.target.files[0]) {
      //let fileurlobj = URL.createObjectURL(e.target.files[0]);
      this.setState({
        file: e.target.files[0],
        //fileurl: fileurlobj,
        statusmsg: ""
      });
    }
  }

  onSubmit(e) {
    e.preventDefault();


    let formdata = new FormData();

    formdata.append("_id", this.state._id);
    //  formdata.append("property_id", this.state.property_id);
    formdata.append("id", this.state.id);

    formdata.append("company_id", this.state.company_id);
    formdata.append("title", this.state.title);
    formdata.append("start_date", this.state.start_date);
    formdata.append("end_date", this.state.end_date);
    formdata.append("price", this.state.price);
    formdata.append("retail", this.state.retail);
    formdata.append("bedrooms", this.state.bedrooms);
    formdata.append("baths", this.state.baths);
    formdata.append("room_type", this.state.room_type);
    formdata.append("categories", this.state.categories);
    formdata.append("booking_url", this.state.booking_url);
    // formdata.append("status_flag", this.state.status_flag);
    formdata.append("delete_flag", this.state.delete_flag);
    // formdata.append("lok", this.state.lok);
    // formdata.append("ppn", this.state.ppn);
    formdata.append("property_key", this.state.property_key);


    //const id = this.props.match.params.id;

    // console.log(this.state.start_date, this.state.end_date);




    if (this.state.which === 'modify') {
      this.props.modifyAccommodation(formdata, this.props.history);
    } else {
      this.props.insertAccommodation(formdata, this.props.history);
    }

  }


  handleChange = name => {
    this.setState({ name });
    console.log("handleChange", name);
  };


  handleSelect = name => {
    //console.log("handleSelect", lookup);
    let rary = name.split(",");
    let tname = rary[0];
    this.setState({
      name: tname
      // lookup: tname
    });
  }

  render() {
    const { errors } = this.state;
    const { advertise } = this.props;
    const perrors = this.props.errors;
    const lat = this.state.latitude;
    const lon = this.state.longitude;
    const { which } = this.state;

    // if (this.state.isloading) {
    //   return <Spinner />;
    // }


    const searchOptions = {};

    let title = "Create";
    if (which === 'modify') {
      title = "Modify";
    }


    return (
      <div className="register">
        <div className="container">
          <div className="row">
            <div className="col-md-8 m-auto shadow-lg p-4">
              <p className=" text-center">{title} Accommodation</p>

              <form noValidate onSubmit={this.onSubmit}>


                <div className="row">
                  <div className="col-md-2">
                    Title</div>
                  <div className="col-md-10">
                    <TextFieldGroupPlain
                      type="text"
                      label="Title"
                      placeholder="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.onChange}
                      error={errors.title}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    Start
                    </div>
                  <div className="col-md-4">
                    <TextFieldGroupPlain
                      type="date"
                      label="Start"
                      placeholder="Start Date"
                      name="start_date"
                      value={this.state.start_date}
                      onChange={this.onChange}
                      error={errors.start_date}
                    />

                  </div>
                  <div className="col-md-2">
                    End
                    </div>
                  <div className="col-md-4">
                    <TextFieldGroupPlain
                      type="date"
                      label="End"
                      placeholder="End Date"
                      name="end_date"
                      value={this.state.end_date}
                      onChange={this.onChange}
                      error={errors.end_date}
                    />


                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    Price
                    </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="price"
                      placeholder="price"
                      name="price"
                      value={this.state.price}
                      onChange={this.onChange}
                      error={errors.price}
                    />
                  </div>
                  <div className="col-md-2">
                    Retail
                    </div>
                  <div className="col-md-2">

                    <TextFieldGroupPlain
                      type="text"
                      label="retail"
                      placeholder="retail"
                      name="retail"
                      value={this.state.retail}
                      onChange={this.onChange}
                      error={errors.retail}
                    />
                  </div>

                  <div className="col-md-2">
                    ID
                  </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="id"
                      placeholder="id"
                      name="id"
                      value={this.state.id}
                      onChange={this.onChange}
                      error={errors.id}
                    />

                  </div>


                </div>




                <div className="row">
                  <div className="col-md-2">
                    type
                  </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="room_type"
                      placeholder="room_type"
                      name="room_type"
                      value={this.state.room_type}
                      onChange={this.onChange}
                      error={errors.room_type}
                    />
                  </div>
                  <div className="col-md-2">
                    Bedrooms
                    </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="bedrooms"
                      placeholder="bedrooms"
                      name="bedrooms"
                      value={this.state.bedrooms}
                      onChange={this.onChange}
                      error={errors.bedrooms}
                    />

                  </div>
                  <div className="col-md-2">
                    Baths
                    </div>
                  <div className="col-md-2">
                    <TextFieldGroupPlain
                      type="text"
                      label="baths"
                      placeholder="baths"
                      name="baths"
                      value={this.state.baths}
                      onChange={this.onChange}
                      error={errors.baths}
                    />

                  </div>


                </div>


                <div className="row">
                  <div className="col-md-2">
                    Categories</div>
                  <div className="col-md-10">

                    <TextAreaGroup
                      type="text"
                      label="categories"
                      placeholder="categories"
                      name="categories"
                      value={this.state.categories}
                      onChange={this.onChange}
                      error={errors.categories}
                    />
                  </div></div>
                <div className="row">
                  <div className="col-md-2">
                    URL</div>
                  <div className="col-md-10">



                    <TextFieldGroupPlain
                      type="text"
                      label="booking_url"
                      placeholder="booking_url"
                      name="booking_url"
                      value={this.state.booking_url}
                      onChange={this.onChange}
                      error={errors.booking_url}
                    />
                  </div>
                </div>











                <input type="submit" className="btn btn-info btn-block mt-4" />
              </form>
              {perrors && (
                <div className="error-display">{perrors.message}</div>
              )}
              {/* <div className="row" style={{ marginTop: "20px" }}>
                <div className="col-md-12">
                  <MapLookup
                    handleMapClick={this.handleMapClick}
                    lat={lat}
                    lon={lon}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div >
    );
  }
}

// this is good practice because it will help debugging
// it is not checked when in production mode.
// Business.propTypes = {
//   createBusiness: PropTypes.func.isRequired,
//   modifyBusiness: PropTypes.func.isRequired,
//   auth: PropTypes.object.isRequired,
//   errors: PropTypes.object.isRequired
// };

// map errors to this component
// then we can use this.props.auth.user etc
// since we mapped error, we can use componentWillReceiveProps method
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  advertise: state.advertise
});
// the state.auth above comes from rootReducer in index.js in reducers.

export default connect(
  mapStateToProps,
  { modifyAccommodation, insertAccommodation }
)(withRouter(AccommodationForm));
// wrap the Register with withRouter so the authAction can use history to redirect



// WEBPACK FOOTER //
// ./src/components/deals/forms/AccommodationForm.js